$(function() {
  $(document).on('submit','form#edit-form',function() {
    let $ngroup_templates = $(this).find('.ngroup-template');
    if($ngroup_templates.length > 0) {
      $ngroup_templates.remove();
    }
 });
});